import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { MaskedButtonContainer as a, MaskedButtonCorner as d, MaskedButtonCornerBend as s, MaskedButtonMaskedArea as i } from "./style.js";
function m({
  children: e,
  maskedContent: n,
  ...o
}) {
  return /* @__PURE__ */ r(a, { ...o, children: [
    e,
    /* @__PURE__ */ t(d, { children: /* @__PURE__ */ t(s, {}) }),
    /* @__PURE__ */ t(
      i,
      {
        role: "presentation",
        "data-masked": n,
        "data-testid": "masked-content"
      }
    )
  ] });
}
export {
  m as MaskedButton
};
